namespace advisorop.components.common {


    export class CuProposalController {
        onProposalCreate: any;
        onProposalSign: any;
        account: domains.IAccount;
        rtq: domains.IRTQ;
        onCheckedSkippingOption: any;
        fuOptions: DevExpress.ui.dxFileUploaderOptions;
        fuValue: File[] = [];
        onAccountOpenStatusChanged: any;
        isHhrProposal: string;
        custodianReadOnly: boolean;

        isAdvisoryFirmLoaded: boolean = false;
        proposalState = domains.ProposalState;
        dgInvestmentSettings: DevExpress.ui.dxDataGridOptions;
        noDataTextDefault = "There are no investment models";
        noDataTextOffModel = "Off Model";
        noDataText = "There are no investment models";
        otherFees: domains.IOtherProposalFee;
        timesHorizons: Array<domains.ILOV>;
        lovs: Array<domains.ILOV> = [];
        selectedTimeHorizon: domains.ILOV;
        proposalId: number; //when we wish to update proposal...
        investmentModels: Array<domains.IInvestmentModel> = [];
        model: domains.IProposal = {
            id: 0,
            advisorFeeBillingType: domains.FeeBillingType.Percentage,
            proposalState: domains.ProposalState.PREPARING,
            //custodianFee: { id: 0 },
            investmentModels: []
        };
        modelChanged: boolean = false;
        proposalForEdit: domains.IProposal = {};
        im: domains.IProposalInvestmentModel = {};
        unallocatedInvestment: number;
        proposalSigned: boolean = false;
        disableForPost: boolean = false;
        numberBox: DevExpress.ui.dxNumberBoxOptions;
        thisAccountIsFromMapping: boolean = false;
        user: domains.identity.IUser;
        currentAdvisor: domains.IAdvisor;

        advisoryFirmId: number;
        accountType: domains.InvestmentType;
        managers: domains.IAdvisoryFirmManager[] = [];
        filteredManagers: domains.IAdvisoryFirmManager[] = [];
        selManager: domains.IAdvisoryFirmManager;
        orionSyncEnabled: boolean = false;
        products: domains.IAdvisoryFirmProduct[] = [];
        filteredProducts: domains.IAdvisoryFirmProduct[] = [];
        selProduct: domains.IAdvisoryFirmProduct;
        deactivatedInvestments: Array<domains.IProposalInvestmentModel> = [];
        investmentType: any = domains.InvestmentType;
        custodians: domains.ICustodianAdvisoryFirm[] = [];
        selCustodian: domains.ICustodianAdvisoryFirm;
        pricingTypes: domains.ILOV[];
        selPricingType: domains.ILOV;
        // showCheckbox: boolean = false;
        iAmReady: any;
        accountOpened: boolean = false;
        investmentChange: boolean;
        cancelProposal: any;
        creatingProposalLadda: boolean = false;
        updatingProposalLadda: boolean = false;
        completeSigningLadda: boolean = false;
        signingProposalLadda: boolean = false;

        public billingTypes = [
            { text: "Percentage", value: domains.FeeBillingType.Percentage },
            { text: "Annual $", value: domains.FeeBillingType.Amount },
            { text: "Tiered", value: domains.FeeBillingType.Tiered }
        ];
        selAdvisorBillingType: { text: string; value: domains.FeeBillingType };
        public billingTypeEnum = domains.FeeBillingType;

        parsedBilling: domains.IAdvancedBillingInfo = {};

        // Advanced Billing editing
        advancedBilling: domains.IAdvancedBillingInfo = {};
        billingStyles = [
            { value: 1, description: "Advanced" },
            { value: 2, description: "Arrear" }
        ];
        billingFrequencies = [
            { value: 1, description: "Monthly" },
            { value: 2, description: "Quarterly" },
            { value: 3, description: "Tri-Annual" },
            { value: 4, description: "Semi-Annual" },
            { value: 5, description: "Annual" },
            { value: 6, description: "At-Maturity" }
        ];
        billingCycleMonthOptions: { value: number; description: string }[] = [];
        selBillingStyle: { value: number; description: string };
        selBillingFrequency: { value: number; description: string };
        selBillingCycleMonth: { value: number; description: string };
        showBillingFrequencyAndCycleFields: boolean = false;

        static $inject = ["advisorService", "generalService", "identityService", "$filter", "$scope", "advisoryFirmApi"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            public $filter, private $scope: ng.IScope,
            private advisoryFirmApi: services.AdvisoryFirmApi) {
            if (!this.model.id || this.model.id <= 0)
                this.unallocatedInvestment = 100;
            else
                this.unallocatedInvestment = 0;

            this.im.percentage = this.unallocatedInvestment;

            this.dgInvestmentSettings = {
                export: {
                    enabled: true,
                    fileName: "InvestmentModels"
                },
                bindingOptions: {
                    dataSource: "vm.model.investmentModels",
                    noDataText: "vm.noDataText",
                    //,"columns[0].lookup.dataSource": "vm.investmentModels"
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,

                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                columns: [
                    { dataField: "managerProductName", caption: "Product", visible: true },
                    { dataField: "productTypeName", caption: "Type", visible: true },
                    { dataField: "managerName", caption: "Manager", visible: true },
                    { dataField: "percentage", caption: "Percentage", format: { type: "percent", precision: 2 }, visible: true },
                    { dataField: "amount", caption: "Amount", format: { type: "fixedPoint", precision: 2 }, visible: true },
                    { dataField: "managerFeePercentage", caption: "Mgr. fee (%)", format: { type: "decimal", precision: 4 }, visible: true },
                    //{ dataField: "managerFeeAmount", caption: "Mgr. fee", format: { type: "fixedPoint", precision: 2 }, visible: true },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions" }
                ]
            };

            this.fuOptions = {
                bindingOptions: {
                    value: "vm.fuValue",
                    uploadUrl: "vm.propUploadUrl"
                },
                selectButtonText: "Select signed proposal document",
                labelText: "",
                multiple: false,
                uploadMode: "useButtons",
                accept: "*", // image/*  or video/*
                uploadButtonText: "Upload signed proposal"
            };

        }

        public get propUploadUrl(): string {
            return `/api/advisor/uploadsignedproposal/${this.model.id}/${this.model.accountId}`;
        }

        onFeeStructureChange(feeStructure: string, isValid: boolean, validationMessage: string): void {
            this.model.advisorFeeDescription = feeStructure;
            this.onModelChange();
        }

        onModelChange(): void {
            this.modelChanged = false;
            if (this.proposalForEdit == undefined) {
                this.modelChanged = true;
                return;
            }

            this.modelChanged = this.model.amount != this.proposalForEdit.amount ||
                this.model.advisorFeeBillingType != this.proposalForEdit.advisorFeeBillingType ||
                this.model.advisorFee != this.proposalForEdit.advisorFee ||
                this.model.advisorFeeDescription != this.proposalForEdit.advisorFeeDescription ||
                this.model.custodianAdvisoryFirmId != this.proposalForEdit.custodianAdvisoryFirmId ||
                this.model.custodianPricingType != this.proposalForEdit.custodianPricingType ||
                this.model.description != this.proposalForEdit.description ||
                this.model.notes != this.proposalForEdit.notes ||
                this.model.investmentModels.length != this.proposalForEdit.investmentModels.length ||
                this.model.investmentDescription != this.proposalForEdit.investmentDescription;

            if (this.modelChanged) {
                return;
            }

            // check if the models have changed
            this.model.investmentModels.forEach(i => {
                var oldInvestmentModel = this.proposalForEdit.investmentModels.filter(oi => (oi.managerId == i.managerId &&
                    oi.managerProductId == i.managerProductId &&
                    oi.managerFeePercentage == i.managerFeePercentage &&
                    oi.managerFeeAmount == i.managerFeeAmount &&
                    oi.amount == i.amount &&
                    oi.percentage == i.percentage &&
                    oi.productTypeId == i.productTypeId))
                if (oldInvestmentModel.length == 0) {
                    this.modelChanged = true;
                    return;
                }
            })
        }

        onChangeAccountOpenStatus(): void {
            this.model.accountSetupOpen = !this.model.accountSetupOpen;
            this.onAccountOpenStatusChanged({
                status: this.model.accountSetupOpen = !this.model.accountSetupOpen
            });
            this.model.amount = 0;
            this.model.description = null;
            this.model.isDiscretionDocumentationOnFile = false;
            this.amountChanged();
        }

        amountChanged(): void {
            this.onModelChange();
            if (!this.model || !this.model.investmentModels)
                return;

            for (var i = 0; i < this.model.investmentModels.length; i++) {
                this.model.investmentModels[i].amount = this.model.investmentModels[i].percentage * this.model.amount;
                this.model.investmentModels[i].managerFeeAmount = this.model.investmentModels[i].amount * this.model.investmentModels[i].managerFeePercentage;
            }
        };

        addInvestment(): void {

            if (!this.selProduct) {
                toastr.error("Please select product from the Product list");
                return;
            }

            const isOrionEclipseModel = this.selProduct.managerName.indexOf('Orion') === 0;
            if (isOrionEclipseModel && this.im.percentage != 100) {
                toastr.error("Orion (Eclipse) model must be only investment and 100% allocated");
                this.im.percentage = 100;
                return null;
            }

            if (this.unallocatedInvestment - this.im.percentage < 0) {
                toastr.error("You cannot allocate more than 100% of investments.");
                this.im.percentage = this.unallocatedInvestment;
                return null;
            }
            else if (this.im.percentage <= 0 || !this.im.percentage) {
                toastr.error("Investment must be greather then zero");
                return null;
            }
            
            //this.im.investmentModelId = this.im.investmentModel.id;
            this.im.percentage = this.im.percentage / 100;
            this.im.managerFeePercentage = this.selProduct.managerFee;
            this.im.amount = this.im.percentage * this.model.amount;
            this.im.managerFeeAmount = 0; //this.im.amount * this.im.managerFeePercentage;

            this.im.managerProductId = this.selProduct.managerProductId;
            this.im.managerProductName = this.selProduct.name;
            this.im.managerId = this.selProduct.managerId;
            this.im.managerName = this.selProduct.managerName;
            this.im.productTypeId = this.selProduct.productTypeId;
            this.im.productTypeName = this.selProduct.productTypeName;

            this.model.investmentModels.push(this.im);

            this.model.isOffModel = false;
            this.noDataText = this.noDataTextDefault;

            this.unallocatedInvestment = this.unallocatedInvestment - this.im.percentage * 100;

            this.im = {};
            this.im.percentage = this.unallocatedInvestment;
            this.onModelChange();
        };

        removeInvestment(im: domains.IProposalInvestmentModel): void {
            var ind = this.model.investmentModels.indexOf(im);
            if (ind >= 0) {
                this.unallocatedInvestment = this.unallocatedInvestment + im.percentage * 100;
                if (this.unallocatedInvestment > 100)
                    this.unallocatedInvestment = 100;
                this.im.percentage = this.unallocatedInvestment;
                this.model.investmentModels.splice(ind, 1);
                this.deactivatedInvestments.splice(ind, 1);
            }
        };

        checkIsSelectedProductProposalInvestmentModels(accountId: number): void {
            this.advisorService.checkIsProductInactiveForProposalInvestments(accountId)
                .then(response => {
                    this.deactivatedInvestments = response.data;
                })
                .catch(error => {
                    toastr.error("Unable to check product.");
                })
        };

        completeSigning(): void {
            this.createOrUpdateProposal("S");
        }

        toggleOffModel(): void {
            this.model.isOffModel = this.model.isOffModel ? false : true;
            this.model.investmentModels = this.model.isOffModel ? [] : angular.copy(this.proposalForEdit.investmentModels);
            this.noDataText = this.model.isOffModel ? this.noDataTextOffModel : this.noDataTextDefault;
            this.unallocatedInvestment = this.model.investmentModels.reduce((x, model) => {
                return x - (model.percentage * 100);
            }, 100);
            this.onModelChange()
//            this.createOrUpdateProposal("C");
        }

        createProposal(): void {
            // when updating a proposal from an active proposal on a account summary dashboard, the  id needs to be 0 to create a new proposal
            this.model.id = 0;
            this.model.investmentModels.forEach(i => {
                i.proposalId = 0;
                i.id = 0;
            });
            this.createOrUpdateProposal("C");
        }

        updateProposal(): void {
            this.createOrUpdateProposal("U");
        }

        createOrUpdateProposal(action: string): void {
            if (action == "C")
                this.creatingProposalLadda = true;
            else if (action == "U")
                this.updatingProposalLadda = true;
            else if (action == "S")
                this.completeSigningLadda = true;

            if (!this.validateProposalForm()) {
                if (action == "C")
                    this.creatingProposalLadda = false;
                else if (action == "U")
                    this.updatingProposalLadda = false;
                else if (action == "S")
                    this.completeSigningLadda = false;
                return;
            }

            // 
            if (this.model.accountSetupOpen && this.showCheckBox) {
                this.model.description = null;
                this.model.amount = null;
            }

            //only for broker dealer - if they defined
            if (this.rtq && this.rtq.id && this.rtq.id > 0) {
                this.model.rtqId = this.rtq.id;
            }

            //if (this.model.proposalState == domains.ProposalState.SIGNED || this.model.isDiscretionDocumentationOnFile)
            //    this.model.proposalState = domains.ProposalState.ACTIVE;

            if (this.deactivatedInvestments.length != 0) {
                this.deactivatedInvestments
                    .map(v => toastr.error("Selected product: " + v.managerProductName + " is not active please select other one."));
                if (action == "C")
                    this.creatingProposalLadda = false;
                else if (action == "U")
                    this.updatingProposalLadda = false;
                else if (action == "S")
                    this.completeSigningLadda = false;
                return;
            }

            if (!this.isHhrProposal) {
                this.model.titleId = this.account.titleId;
                this.model.accountId = this.account.id;
            }

            if (this.selCustodian)
                this.model.custodianAdvisoryFirmId = this.selCustodian.id;
            else
                this.model.custodianAdvisoryFirmId = null;

            if (this.selPricingType)
                this.model.custodianPricingType = this.selPricingType.value;
            else
                this.model.custodianPricingType = null;

            this.advisorService.createOrUpdateProposal(this.model)
                .then(response => {
                    this.model = response.data;
                    this.account.proposal = response.data;

                    // notify angular that account has been changed...
                    let tmp = this.account;
                    this.account = {};
                    this.account = tmp;

                    this.onProposalCreate({ proposal: response.data });

                    var typ = "Proposal";
                    if (this.model.accountSetupOpen)
                        typ = "Setup";
                    if (this.proposalForEdit.id) {
                        toastr.info(`${typ} has been updated.\nPlease Sign the proposal.`);
                    } else {
                        toastr.success(`${typ} successfully created.`);
                    }
                    if (this.investmentChange) {
                        this.closeFrom();
                    }

                    // GL added this line so that after creating a proposal the messages after
                    // pressing the save button ("update" vs "modify") will work in the new-account-wiz.
                    this.proposalForEdit.id = this.model.id;

                }, err => this.generalService.showError(err)).finally(() => {
                    if (action == "C")
                        this.creatingProposalLadda = false;
                    else if (action == "U")
                        this.updatingProposalLadda = false;
                    else if (action == "S")
                        this.completeSigningLadda = false;
                });
        }

        signProposal(doc: any): void {
            this.signingProposalLadda = true;

            this.advisorService
                .signProposal(this.model)
                .then((response) => {
                    angular.copy(response.data, this.model);
                    this.account.proposal = this.model;

                    // this event can be used if we wish activate proposal after signing
                    this.onProposalSign({ proposal: this.model});

                }, err => this.generalService.showError(err)).finally(() => {
                    this.signingProposalLadda = false;
                });
        }

        setProposal(proposal: domains.IProposal): void {
            // console.log(`CuProposal setProposal: setting proposal ${JSON.stringify(proposal)}`);
            if (this.investmentChange) {
                this.model = this.proposalForEdit;
            } else {
                this.model = proposal;
                this.selectAdvisorBillingType();
                this.selectTimeHorizon();
                this.bindCustodianDdFromModel();
            }
            if (this.model.advisorCreate) this.model.advisorCreate.companyGroup = null;
            this.model.title = null;
            this.unallocatedInvestment = 0;
            this.im.percentage = this.unallocatedInvestment;

            // Parse and restore advanced billing
            if (this.model.advancedBillingInfo) {
                try { this.parsedBilling = JSON.parse(this.model.advancedBillingInfo); } catch (e) { this.parsedBilling = {}; }
            } else {
                this.parsedBilling = {};
            }
            this.restoreAdvancedBilling();
        };

        // --- Advanced Billing methods ---

        onBillingStyleSelected(): void {
            this.advancedBilling.style = this.selBillingStyle ? { value: this.selBillingStyle.value, description: this.selBillingStyle.description } : null;
            if (this.advancedBilling.style) {
                this.applyBillingDefaultsForHiddenFields();
            } else {
                this.selBillingFrequency = null;
                this.selBillingCycleMonth = null;
                this.advancedBilling.frequency = null;
                this.advancedBilling.cycleMonth = null;
                this.billingCycleMonthOptions = [];
            }
            this.syncAdvancedBillingToModel();
        }

        onBillingFrequencySelected(): void {
            this.advancedBilling.frequency = this.selBillingFrequency ? { value: this.selBillingFrequency.value, description: this.selBillingFrequency.description } : null;
            this.selBillingCycleMonth = null;
            this.advancedBilling.cycleMonth = null;
            this.updateCycleMonthOptions();
            this.syncAdvancedBillingToModel();
        }

        onBillingCycleMonthSelected(): void {
            this.advancedBilling.cycleMonth = this.selBillingCycleMonth ? { value: this.selBillingCycleMonth.value, description: this.selBillingCycleMonth.description } : null;
            this.syncAdvancedBillingToModel();
        }

        private applyBillingDefaultsForHiddenFields(): void {
            if (!this.advancedBilling.style) {
                return;
            }

            if (!this.selBillingFrequency) {
                this.selBillingFrequency = this.billingFrequencies.find(f => f.value === 1) || null;
            }

            if (this.selBillingFrequency) {
                this.advancedBilling.frequency = {
                    value: this.selBillingFrequency.value,
                    description: this.selBillingFrequency.description
                };
            }

            this.updateCycleMonthOptions();

            if (!this.selBillingCycleMonth) {
                this.selBillingCycleMonth = this.billingCycleMonthOptions.find(c => c.value === 1)
                    || this.billingCycleMonthOptions[0]
                    || null;
            }

            if (this.selBillingCycleMonth) {
                this.advancedBilling.cycleMonth = {
                    value: this.selBillingCycleMonth.value,
                    description: this.selBillingCycleMonth.description
                };
            }
        }

        updateCycleMonthOptions(): void {
            if (!this.selBillingFrequency) {
                this.billingCycleMonthOptions = [];
                return;
            }
            switch (this.selBillingFrequency.value) {
                case 1: // Monthly
                    this.billingCycleMonthOptions = [{ value: 1, description: "Every Month" }];
                    break;
                case 2: // Quarterly
                    this.billingCycleMonthOptions = [
                        { value: 1, description: "Month 1 of Quarter" },
                        { value: 2, description: "Month 2 of Quarter" },
                        { value: 3, description: "Month 3 of Quarter" }
                    ];
                    break;
                case 3: // Tri-Annual
                case 5: // Annual
                case 6: // At-Maturity
                    this.billingCycleMonthOptions = [
                        { value: 1, description: "Month 1 of Year" }, { value: 2, description: "Month 2 of Year" },
                        { value: 3, description: "Month 3 of Year" }, { value: 4, description: "Month 4 of Year" },
                        { value: 5, description: "Month 5 of Year" }, { value: 6, description: "Month 6 of Year" },
                        { value: 7, description: "Month 7 of Year" }, { value: 8, description: "Month 8 of Year" },
                        { value: 9, description: "Month 9 of Year" }, { value: 10, description: "Month 10 of Year" },
                        { value: 11, description: "Month 11 of Year" }, { value: 12, description: "Month 12 of Year" }
                    ];
                    break;
                case 4: // Semi-Annual
                    this.billingCycleMonthOptions = [
                        { value: 1, description: "Month 1 of Semi-Annual Cycle" }, { value: 2, description: "Month 2 of Semi-Annual Cycle" },
                        { value: 3, description: "Month 3 of Semi-Annual Cycle" }, { value: 4, description: "Month 4 of Semi-Annual Cycle" },
                        { value: 5, description: "Month 5 of Semi-Annual Cycle" }, { value: 6, description: "Month 6 of Semi-Annual Cycle" }
                    ];
                    break;
                default:
                    this.billingCycleMonthOptions = [];
                    break;
            }
        }

        syncAdvancedBillingToModel(): void {
            if (this.advancedBilling.style) {
                this.applyBillingDefaultsForHiddenFields();
            }
            this.model.advancedBillingInfo = JSON.stringify(this.advancedBilling);
            this.parsedBilling = Object.assign({}, this.advancedBilling);
            this.modelChanged = true;
        }

        restoreAdvancedBilling(): void {
            if (this.model.advancedBillingInfo) {
                try {
                    this.advancedBilling = JSON.parse(this.model.advancedBillingInfo);
                } catch (e) {
                    this.advancedBilling = {};
                }
            } else {
                this.advancedBilling = {};
            }

            if (this.advancedBilling.style) {
                this.selBillingStyle = this.billingStyles.find(s => s.value === this.advancedBilling.style.value) || null;
            }
            if (this.advancedBilling.frequency) {
                this.selBillingFrequency = this.billingFrequencies.find(f => f.value === this.advancedBilling.frequency.value) || null;
                this.updateCycleMonthOptions();
            }
            if (this.advancedBilling.cycleMonth) {
                this.selBillingCycleMonth = this.billingCycleMonthOptions.find(c => c.value === this.advancedBilling.cycleMonth.value) || null;
            }

            if (this.advancedBilling.style) {
                this.applyBillingDefaultsForHiddenFields();
            }
        }

        validateProposalForm(): boolean {

            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["form"]);

            if (!formIsValid) {
                toastr.error("Proposal form is not complete. Please correct errors and try again.");
                return false;
            }

            //console.log("SETUP OPEN", this.model.accountSetupOpen);
            //console.log("INVESTMENT AMOUNT", this.model.amount);

            if (!this.investmentChange && !this.model.accountSetupOpen && this.model.amount <= 0) {
                toastr.error("Investment amount must be greater than 0.");
                return false;
            }

            if (this.model.advisorFeeBillingType === null || this.model.advisorFeeBillingType === undefined) {
                toastr.error("Advisor Fee Billing type needs to be selected.");
                this.model.advisorFeeBillingType = domains.FeeBillingType.Percentage;
                return false;
            }

            if (this.model.advisorFeeBillingType === domains.FeeBillingType.Tiered && (!this.model.advisorFeeDescription || this.model.advisorFeeDescription.length < 15)) {
                toastr.error("Advisor Fee structure must have at least 15 characters.");
                return false;
            }

            if ([domains.FeeBillingType.Percentage, domains.FeeBillingType.Amount].includes(this.model.advisorFeeBillingType)) {
                if (this.model.advisorFee == null || this.model.advisorFee < 0) {
                    toastr.error("Please enter a valid advisor fee (0 or greater). Even if you see 0.00%, type 0 to confirm no fee.");
                    this.model.advisorFee = 0;
                    return false;
                }

                if ((this.model.advisorFeeBillingType ?? domains.FeeBillingType.Percentage) === domains.FeeBillingType.Percentage && this.model.advisorFee > 100) {
                    toastr.error("Advisor fee needs to be between 0% and 100%.");
                    // this.model.advisorFee = 0;
                    return false;
                }
            }

            //console.log("UNALLO INVEST", this.unallocatedInvestment);
            //console.log("HAS INVEST", this.hasInvestmentModel());
            //console.log("IDFOREDIT INVEST", this.proposalForEdit.id);

            if (this.unallocatedInvestment != 0 && this.hasInvestmentModel() && !this.proposalForEdit.id && this.model.isOffModel != true) {
                toastr.error("Please finish allocating investments");
                return false;
            }

            if (this.advancedBilling.style) {
                this.applyBillingDefaultsForHiddenFields();
                this.model.advancedBillingInfo = JSON.stringify(this.advancedBilling);
            }

            return formIsValid;
        };

        selectTimeHorizon(): void {
            if (this.timesHorizons) {
                var thInd = this.timesHorizons.map(m => m.value).indexOf(this.model.timeHorizon);
                if (thInd >= 0) {
                    this.selectedTimeHorizon = this.timesHorizons[thInd];
                    //console.log(this.selectedTimeHorizon);
                }
            }
        };

        selectAdvisorBillingType(): void {
            if (this.billingTypes) {
                var thInd = this.billingTypes.map(m => m.value).indexOf(this.model.advisorFeeBillingType);
                if (thInd >= 0) {
                    this.selAdvisorBillingType = this.billingTypes[thInd];
                    this.onAdvisorBillingTypeSelected(false);
                }
            }
        };

        loadProposal(proposalId: number): void {
            //console.log(`CuProposal: Loading proposal ${proposalId} ...`);
            this.advisorService.getProposal(proposalId)
                .then(response => this.setProposal(response.data), err => this.generalService.showError(err));
        };

        loadManagers(advisoryFirmId: number): ng.IPromise<domains.IAdvisoryFirmManager[]> {
            // we need to filter managers by product type if product type selected on first screen
            //console.log(`CuProposal: Loading managers for advisory firm ${advisoryFirmId} ...`);
            return this.advisoryFirmApi.getManagers(advisoryFirmId)
                .then(response => {
                    this.managers = response.data;
                    // console.log("CuProposal: Managers loaded...", this.managers);
                    return this.managers;
                }, err => this.generalService.showError(err));
        };

        loadProducts(advisoryFirmId: number): ng.IPromise<domains.IAdvisoryFirmProduct[]> {
            // console.log(`CuProposal: Loading products for the firm: [${advisoryFirmId}], tampId: [${this.account.tampId}] ...`);
            return this.advisoryFirmApi.getProducts(advisoryFirmId, this.account.tampId)
                .then(response => {
                    this.products = response.data;
                    // console.log(`Products has been loaded`, this.products.length, this.products);
                    this.filterManagers();
                    return response.data;
                }, err => toastr.error("Products has not been loaded. " + err.data));
        };

        syncOrionModels(): ng.IPromise<void> {
            toastr.info("Syncing Orion (Eclipse) models. Please wait...");
            return this.advisoryFirmApi.syncOrionModels(this.advisoryFirmId)
                .then(() => {
                    this.loadProducts(this.advisoryFirmId).then(() => this.filterProducts());
                    toastr.success("Orion (Eclipse) models have been synced.");
                }, err => toastr.error("SyncOrionModels error " + err.data));
        };
        
        filterProducts() {

            //console.log("Filtering products...");
            // console.log("Filtering products...", this.products, "Manager", this.managers, " Selected manager: ", this.selManager);

            // manager must be selected first
            if (!this.selManager) {
                return;
            }

            // we need to filter products by manager
            this.filteredProducts = this.products.filter(v => v.managerId == this.selManager.managerId);

            // console.log("Stage 1: ", this.filteredProducts);

            // if we have product type selected then filter products by managerid and products type
            if (this.account && this.account.productTypeId > 0) {
                this.filteredProducts = this.filteredProducts.filter(v => v.productTypeId == this.account.productTypeId);
                //console.log("Stage 2: ", this.filteredProducts);
            };

            // Sort filtered products by orionEclipseModelId
            this.filteredProducts.sort((a, b) => {
                return (a.orionEclipseModelId || 0) - (b.orionEclipseModelId || 0);
            });
        };
        
        filterManagers() {
            // console.log(`Filtering managers...`);
            let tmpMgrIds: number[] = [];
            if (this.account && this.account.productTypeId > 0) {
                // console.log(`Filtering managers by productTypeId=${this.account.productTypeId}`);
                tmpMgrIds = this.products.filter(v => v.productTypeId == this.account.productTypeId).map(m => m.managerId);
            }
            else {
                // console.log(`Filtering managers by all products since productTypeId has not been set...`);
                tmpMgrIds = this.products.map(m => m.managerId);
            }

            // select distinct
            tmpMgrIds = tmpMgrIds.filter((v, ind, self) => self.indexOf(v) === ind);

            // console.log(`Managers from product ${tmpMgrIds.join(",")}`);
            this.filteredManagers = this.managers.filter(v => tmpMgrIds.indexOf(v.managerId) >= 0);
        };

        onManagerSelected() {
            // this is hack - we have to read Orion (Eclipse) manager ID from settings 
            this.orionSyncEnabled = this.selManager.managerName.indexOf('Orion') === 0;
            this.filterProducts();
        };

        onAdvisorBillingTypeSelected(clearFeeValues: boolean = true): void {
            this.model.advisorFeeBillingType = this.selAdvisorBillingType.value;
            if (clearFeeValues) {
                this.model.advisorFee = 0;
                this.model.advisorFeeDescription = null;
            }
            this.onModelChange();
        }

        loadInvestmentModels(advisoryFirmId: number): ng.IPromise<domains.IInvestmentModel[]> {
            return this.advisorService.getInvestmentModels(advisoryFirmId)
                .then(response => this.investmentModels = response.data, reason => toastr.error("InvestmentModels error " + reason));
        };

        onChangedSkippOption(): void {
            this.onCheckedSkippingOption({ isDiscretionDocumentationOnFile: this.model.isDiscretionDocumentationOnFile });
            this.onModelChange();
        }

        loadFees(advisoryFirmId: number): void {
            if (!this.investmentChange) {
                this.advisorService.getOtherProposalFees(advisoryFirmId)
                    .then((response) => {
                        this.otherFees = response.data;
                        //this.model.platformFee = response.data.platformFee;
                        //if (this.model && this.model.custodianFee && this.otherFees.custodianFee.length > 0) {
                        //    this.model.custodianFee = this.otherFees.custodianFee.filter(item => item.id == this.model.custodianFee.id)[0];
                        //}
                        // this is default advisor fee which can be overridden by Advisory Manager
                        // console.log(`Setting advisory fee to ${response.data.advisorFee.percentage}`, response.data.advisorFee);
                        this.model.advisorFee = response.data.advisorFee.percentage / 100;

                    }, err => this.generalService.showError(err));
            }
        };

        loadCustodiansForAdvisoryFirm(advisoryFirmId: number): ng.IPromise<void> {
            //console.log("CuProposal: Loading Custodians...");
            return this.advisorService.getCustodiansForAdvisoryFirm(advisoryFirmId)
                .then(data => {
                    this.custodians = data.data;
                    this.bindCustodianDdFromModel();
                }, err => this.generalService.showError(err));
        };

        timeHorizonChanged(): void {
            this.model.timeHorizon = this.selectedTimeHorizon.value;
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.lovs = data;

                    this.timesHorizons = this.lovs.filter(v => v.lovType === domains.LovType.TIME_H);

                    this.selectTimeHorizon();

                    this.pricingTypes = data.filter(f => f.lovType === domains.LovType.PRICING_TYPE);

                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        hasInvestmentModel(): boolean {
            var hasInvestmentModel = this.account && (this.account.accountType == domains.InvestmentType.MANAGED_MODELS || this.account.accountType == domains.InvestmentType.SMA)/*|| this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS*/;
            return hasInvestmentModel;
        };

        isInternalTamp(): boolean {
            return this.account && this.account.tampType === domains.TampType.INTERNAL_TAMP;
        }

        public get showCheckBox(): boolean {
            // On an investment change do not offer the 'setup only' option
            // Offer this option for individual holdings, managed models and sma
            return !this.investmentChange &&
                // ( ( this.model.proposalState == domains.ProposalState.PREPARING) || this.model.accountSetupOpen) &&
                (this.account.accountType === domains.InvestmentType.INDIVIDUAL_HOLDINGS
                    || this.account.accountType === domains.InvestmentType.MANAGED_MODELS
                    || this.account.accountType === domains.InvestmentType.SMA);
        }

        $onInit(): void {

            //console.log("CuProposal: onInit fired");

            this.iAmReady({ ctrl: this });

            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.currentAdvisor = this.user.advisor;
            });
            this.loadLovs();
            if (this.proposalId > 0) {
                this.loadProposal(this.proposalId);
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {

                // console.log(`CuProposal: onChanges fired ${key}`);

                if (key === "rtq") {
                    this.model.rtq = this.rtq;
                } else if (key === "account" && this.account && this.account.id >= 0) {
                    //console.log("CuProposal: account received"/*, this.account*/);

                    //if (this.account.ppAccountId && (this.account.ppAccountId > 0))
                    //    this.thisAccountIsFromMapping = true;
                    //else
                    //    this.thisAccountIsFromMapping = false;

                    // this.showCheckBox();
                    if (this.account && this.account.proposal) {
                        this.setProposal(this.account.proposal);

                        if (this.account.id > 0)
                            this.checkIsSelectedProductProposalInvestmentModels(this.account.id);

                        //if (this.account.number) {
                        //    this.thisAccountIsFromMapping = true;
                        //}
                    }
                    if (this.account.advisoryFirm) {
                        // in this case we need to reload data: managers, products, fees, investment models etc...
                        // baecause firm or tamp has been changed
                        // we have space for optimization here
                        this.isAdvisoryFirmLoaded = false;
                        this.advisoryFirmId = this.account.advisoryFirm.id;
                        this.loadAdvisoryFirm(this.advisoryFirmId);
                    }
                } else if (key === "advisoryFirmId") {
                    this.loadAdvisoryFirm(this.advisoryFirmId);
                } else if (key === "proposalForEdit" && this.investmentChange) {
                    // console.log("CuProposal: proposal for edit received", this.model, this.rtq);
                    if (this.proposalForEdit.id) {
                        this.model = angular.copy(this.proposalForEdit);
                        this.noDataText = this.model.isOffModel ? this.noDataTextOffModel : this.noDataTextDefault;
                        this.selectedTimeHorizon = this.timesHorizons[this.proposalForEdit.timeHorizon];
                        this.bindCustodianDdFromModel();
                        this.selectAdvisorBillingType();
                        this.restoreAdvancedBilling();
                        this.unallocatedInvestment = this.model.investmentModels.reduce((x, model) => {
                            return x - (model.percentage * 100);
                        }, 100);;
                        this.modelChanged = false;
                    } else {
                        // console.log(".... we have new proposal ...");
                        this.model = {
                            id: 0,
                            proposalState: domains.ProposalState.PREPARING,
                            /*custodianFee: { id: 0 },*/
                            investmentModels: [],
                            advisorFeeBillingType: domains.FeeBillingType.Percentage
                        };

                        this.unallocatedInvestment = 100;
                        this.im.percentage = this.unallocatedInvestment;

                        this.resetSelected();

                        this.model.rtq = this.rtq;

                        // we need to reload data
                        this.isAdvisoryFirmLoaded = false;

                        this.advisoryFirmId = this.account.advisoryFirm.id;

                        this.loadAdvisoryFirm(this.advisoryFirmId);

                        // this.amountChanged();
                    }
                    this.selectAdvisorBillingType();
                }
            }
        }

        loadAdvisoryFirm(advisoryFirmId: number) {

            if (!advisoryFirmId) return;

            // load only once
            if (this.isAdvisoryFirmLoaded) return;

            this.isAdvisoryFirmLoaded = true;

            //console.log(`CuProposal: Loading fees, investment model and managers for advisory firm ${advisoryFirmId}`);

            this.loadCustodiansForAdvisoryFirm(advisoryFirmId);
            this.loadFees(advisoryFirmId);
            this.loadInvestmentModels(advisoryFirmId);
            this.loadManagers(advisoryFirmId).then(d => this.loadProducts(advisoryFirmId));
        }

        bindCustodianDdFromModel(): void {
            //console.log("MODEL:", this.model);
            //console.log("CUSTODIANS:", this.custodians);
            //console.log("MODEL CUSTODIAN ADVISORY FIRM ID:", this.model.custodianAdvisoryFirmId);

            if (this.model && this.custodians) {
                if (this.model.custodianAdvisoryFirmId) {
                    var cust = this.custodians.filter((v) => { return v.id == this.model.custodianAdvisoryFirmId; });
                    if (cust.length > 0) {
                        this.selCustodian = cust[0];
                    }
                }
            }
            if (this.model && this.model.custodianPricingType >= 0) {
                this.selPricingType = <domains.ILOV>{ value: this.model.custodianPricingType };
            }
        }

        closeFrom(): void {
            this.cancelProposal({ status: true });
        }

        resetSelected(): void {
            this.orionSyncEnabled = false;
            this.selProduct = {};
            this.selManager = {}; 
            this.selectedTimeHorizon = {};
        }

        $routerOnActivate(next, previous) {
        }
    }


    class CuProposal implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;
        transclude: boolean;

        constructor() {
            this.controller = CuProposalController;
            this.controllerAs = "vm";
            this.transclude = true;
            this.bindings = {
                account: "<",
                rtq: "<",
                onProposalCreate: "&",
                onProposalSign: "&",
                onAccountOpenStatusChanged: "&",
                onCheckedSkippingOption: "&",
                advisoryFirmId: "<",
                investmentChange: "<",
                iAmReady: "&",
                cancelProposal: "&",
                proposalForEdit: "<",
                isHhrProposal: "@",
                custodianReadOnly: "<",
            };
            this.templateUrl = "spa/shared/common/cu-proposal.html";
        }
    }
    angular.module(Constants.APP).component("cuProposal", new CuProposal());
}
